import { Module } from 'vuex';
import { actions } from './actions';
import { Action, CatalogItem } from '@/requests/mainApi';
import { IFlatItem } from '@/views/App/Profile/store/interfaces';
import { RootState } from '@/store';

export const storeModuleName: string = 'profile';

export interface ProfileState {
  bookingFlats: IFlatItem[];
  myFlats: CatalogItem[];
  myFinishedFlats: CatalogItem[];
  actions: Action[];
  actionMain?: Action,
  loadingFlats: boolean;
  loadingFinishedFlats: boolean;
  loadingDeals: boolean;
  stateMainActionModalStatus: boolean;
}

const state: ProfileState = {
  bookingFlats: [],
  myFlats: [],
  myFinishedFlats: [],
  actions: [],
  actionMain: null,
  loadingFlats: false,
  loadingFinishedFlats: false,
  loadingDeals: false,
  stateMainActionModalStatus: false,
};

export const store: Module<ProfileState, RootState> = {
  state,
  getters: {
    bookingFlats(state) {
      return state.bookingFlats;
    },
    myFlats(state) {
      return state.myFlats;
    },
    myFinishedFlats(state) {
      return state.myFinishedFlats;
    },
    actions(state) {
      return state.actions;
    },
    actionMain(state) {
      return state.actionMain;
    },
    loadingFlats(state) {
      return state.loadingFlats;
    },
    loadingFinishedFlats(state) {
      return state.loadingFinishedFlats;
    },
    loadingDeals(state) {
      return state.loadingDeals;
    },
    stateMainActionModalStatus (state) {
      return state.stateMainActionModalStatus
    },
  },
  mutations: {
    setBookingFlats(state, value) {
      state.bookingFlats = value;
    },
    setMyFlats(state, value) {
      state.myFlats = value;
    },
    setMyFinishedFlats(state, value) {
      state.myFinishedFlats = value;
    },
    setActions(state, value) {
      state.actions = value;
    },
    setActionMain(state, value) {
      state.actionMain = value;
    },
    setLoadingFlats(state, value) {
      state.loadingFlats = value;
    },
    setLoadingFinishedFlats(state, value) {
      state.loadingFinishedFlats = value;
    },
    setLoadingDeals(state, value) {
      state.loadingDeals = value;
    },
    setStateMainActionModalStatus (state, value) {
      state.stateMainActionModalStatus = value
    }
  },
  actions,
  namespaced: true,
};
